import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import App1Image from "../../assets/images/app1.svg";
import App2Image from "../../assets/images/app2.svg";
import App3Image from "../../assets/images/app3.svg";
import App4Image from "../../assets/images/app4.svg";
import Section from "../../components/Section";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import videoBg from "../../assets/videos/videoBg.mp4";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import StoreContent from "../../components/StoreContent";
import CategoryCheck from "../../components/CategoryCheck";
import SelectDropDown from "../../components/SelectDropDown";
import { Post } from "../../network/httpClient";
import useWindowSize from "../../../utils/hooks/useWindowSize";

const contactRegardingOptions = [
  { name: "Contact Support", value: "CONTACT_SUPPORT" },
  { name: "Delete Account", value: "DELETE_ACCOUNT" },
  { name: "Recover Account", value: "RECOVER_ACCOUNT" },
];

const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    mobileNo: yup
      .string()
      .required("Mobile number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .length(10, "Must be exactly 10 digits"),
    emailId: yup.string().email().required("Email id is required"),
    profile: yup.array().min(1, "Please select atleast one"),
    contactRegarding: yup.string().required("Please select contact regarding"),
  })
  .required();

const ContactUs = () => {
  const windowSize = useWindowSize();
  const isMobileView = windowSize.x < 950;
  const [errorMessage, setErrorMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [submitted, setSubmitted] = useState(false); // State to track whether the form has been submitted
  const [isFabVisible, setIsFabVisible] = useState(false);
  const positionRef = useRef(0);
  const parallaxRef = useRef(null);
  const debounceTimerRef = useRef(null); // To store the timer ID
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      mobileNo: "",
      emailId: "",
      profile: [],
    },
  });

  const showButtonWithDelay = () => {
    const minLimit = window.innerHeight * 2;
    if (positionRef.current > minLimit) {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      debounceTimerRef.current = setTimeout(() => {
        if (positionRef.current > minLimit) {
          setIsFabVisible(true);
        }
      }, 1000);
    }
  };

  const isMobileLandscape = windowSize.x > windowSize.y && windowSize.x <= 915;

  const onSubmit = async (data) => {
    setErrorMessage("");
    setInfoMessage("");
    console.log(data);
    const request = {
      name: data.name,
      mobileNo: data.mobileNo,
      emailId: data.emailId,
      artist: data.profile?.includes("artist"),
      recruiter: data.profile?.includes("recruiter"),
      contactRegarding: data.contactRegarding,
    };
    try {
      const response = await Post("v1/contactUs/add", request);
      console.log("RESPONSE ------------->", response);
      if (response.code === 200) {
        parallaxRef.current.scrollTo(0);
        setSubmitted(true);
      } else if (response.code === 400) {
        setInfoMessage(response.message);
      } else setErrorMessage(response.message);
    } catch (error) {
      console.log(error);
      setErrorMessage(error?.message);
    }
  };

  const handleScroll = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    parallaxRef.current.scrollTo(1);
    setIsFabVisible(false);
  };

  const checkScrollPosition = () => {
    console.log("Scroll Position:", window.innerHeight);
    if (parallaxRef.current) {
      positionRef.current = parallaxRef.current.current;
      console.log("Current Scroll Position:", positionRef.current);
      showButtonWithDelay();
    }
  };

  return (
    <div className="waitlist main-bg">
      <Parallax
        className="parallax-container"
        ref={parallaxRef}
        pages={isMobileView ? 4.78 : 5.5}
        style={{ top: 0, left: 0, right: 0, bottom: 0 }}
        onScrollCapture={checkScrollPosition}
      >
        <ParallaxLayer
          offset={0}
          speed={0}
          factor={0.2}
          sticky={{ start: 0, end: 0.5 }}
        >
          <div style={{ backgroundColor: "#000000", zIndex: 999 }}>
            <Header />
          </div>
        </ParallaxLayer>
        <ParallaxLayer
          offset={0}
          speed={0}
          factor={1}
          sticky={{ start: 0, end: 0.5 }}
          style={{ zIndex: -2 }}
        >
          <div style={{ position: "relative", height: "100%" }}>
            <div
              className="video-container mesh-overlay"
              style={{ zIndex: 1 }}
            />
            <video
              className="video-container"
              autoPlay="autoplay"
              loop="loop"
              muted
              src={videoBg}
              playsInline
            />
          </div>
        </ParallaxLayer>
        {!submitted ? (
          <ParallaxLayer
            offset={0.3}
            speed={0}
            factor={0.3}
            sticky={{ start: 0.3, end: 0.5 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                height: "100%",
                zIndex: 99,
                boxSizing: "border-box",
              }}
            >
              <h2
                className="main-title"
                style={{ textTransform: "uppercase", margin: 0 }}
              >
                Contact Us
              </h2>
              <form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "440px",
                  zIndex: 99,
                  marginTop: 15,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobileLandscape ? "row" : "column",
                    gap: isMobileLandscape ? 20 : 0,
                  }}
                >
                  <Input
                    control={control}
                    error={errors.name?.message}
                    name="name"
                    label="Person Name"
                    placeholder="Enter Name"
                  />
                  <Input
                    control={control}
                    error={errors.mobileNo?.message}
                    name="mobileNo"
                    label="Mobile Number"
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobileLandscape ? "row" : "column",
                    gap: isMobileLandscape ? 20 : 0,
                  }}
                >
                  <Input
                    control={control}
                    error={errors.emailId?.message}
                    name="emailId"
                    label="Email"
                    placeholder="Enter Email Address"
                  />
                </div>

                <CategoryCheck
                  control={control}
                  name="profile"
                  error={errors.profile?.message}
                />
                <SelectDropDown
                  label={"Contact Regarding"}
                  control={control}
                  name="contactRegarding"
                  error={errors.contactRegarding?.message}
                  options={contactRegardingOptions}
                />
                {errorMessage && (
                  <div className="error-box">
                    <span className="">{errorMessage}</span>
                  </div>
                )}
                {infoMessage && !errorMessage && (
                  <div className="info-box">
                    <span className="">{infoMessage}</span>
                  </div>
                )}
                <Button value="Submit"></Button>
              </form>
            </div>
          </ParallaxLayer>
        ) : (
          <ParallaxLayer
            className="dark-bg"
            offset={0}
            speed={0}
            factor={0}
            sticky={{ start: 0.2, end: 0.5 }}
          >
            <div
              style={{
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 20px",
                flexDirection: "column",
              }}
            >
              <h2 className="main-title" style={{ textTransform: "uppercase" }}>
                Thank you for your request, we will get back to you shortly
              </h2>
              <div className="thankyou"></div>
            </div>
          </ParallaxLayer>
        )}

        <ParallaxLayer offset={2} speed={0} factor={isMobileView ? 0.62 : 0.8}>
          <Section
            appImage={App1Image}
            title="Create Your Profile and Get Discovered"
            subtitle="Build your portfolio and become part of the industry."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 2.62 : 2.8}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}
        >
          <Section
            reverse
            appImage={App4Image}
            title="Apply for Auditions across India"
            subtitle="Artists can apply for auditions taking place all over India."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 3.24 : 3.6}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}
        >
          <Section
            appImage={App2Image}
            title="Create Auditions and Streamline Talent Discovery and Hiring"
            subtitle="Find the best talent for your project and organise your database."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 3.86 : 4.4}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}
        >
          <Section
            reverse
            appImage={App3Image}
            title="Learn from Industry Experts in Exclusive Masterclasses"
            subtitle="Elevate your craft under the guidance of industry legends."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 4.48 : 5.2}
          speed={0}
          factor={0.3}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <StoreContent />
            <Footer />
          </div>
        </ParallaxLayer>
      </Parallax>
    </div>
  );
};

export default ContactUs;
